import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Flex, Logo, Typography } from '@percent/lemonade'
import styles from './Footer.module.scss'
import { PRIVACY_POLICY_URL, TERMS_URL } from '@percent/education-hosted-form/constants/legalUrls'

export const GOODSTACK_URL = 'https://goodstack.io/'

function FooterLink({ children, to }: { children: React.ReactNode; to: string }) {
  return (
    <Link to={to} className={styles.footerLink} target="_blank" rel="noopener noreferrer">
      <Typography className={styles.termsPrivacy}>{children}</Typography>
    </Link>
  )
}

export function Footer() {
  const { t } = useTranslation()

  return (
    <Flex className={styles.footerWrapper}>
      <Flex align="center" gap={8}>
        <Typography className={styles.poweredBy}>{t('typography.poweredBy')}</Typography>
        <Link to={GOODSTACK_URL} target="_blank" rel="noopener noreferrer">
          <Logo className={styles.logo} />
        </Link>
      </Flex>
      <Flex align="center" gap={4}>
        <FooterLink to={TERMS_URL}>{t('typography.terms')}</FooterLink>
        <Typography className={styles.termsPrivacy}>•</Typography>
        <FooterLink to={PRIVACY_POLICY_URL}>{t('typography.privacy')}</FooterLink>
      </Flex>
    </Flex>
  )
}
